var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8.44444C4 5.98985 5.98985 4 8.44444 4H15.5556C18.0102 4 20 5.98985 20 8.44444V19.5C20 20.0523 19.5523 20.5 19 20.5C18.4477 20.5 18 20.0523 18 19.5V18.1111H6V19.5C6 20.0523 5.55228 20.5 5 20.5C4.44772 20.5 4 20.0523 4 19.5V8.44444ZM7.11111 16.3333C6.37473 16.3333 5.77778 15.7364 5.77778 15C5.77778 14.2636 6.37473 13.6667 7.11111 13.6667H8.88889C9.62527 13.6667 10.2222 14.2636 10.2222 15C10.2222 15.7364 9.62527 16.3333 8.88889 16.3333H7.11111ZM18.2222 11.8889V8.44444C18.2222 6.97169 17.0283 5.77778 15.5556 5.77778H8.44444C6.97169 5.77778 5.77778 6.97169 5.77778 8.44444V11.8889H18.2222ZM16.8889 13.6667C17.6253 13.6667 18.2222 14.2636 18.2222 15C18.2222 15.7364 17.6253 16.3333 16.8889 16.3333H15.1111C14.3747 16.3333 13.7778 15.7364 13.7778 15C13.7778 14.2636 14.3747 13.6667 15.1111 13.6667H16.8889Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBus);
export default __webpack_public_path__ + "static/media/icon_bus.e9098b253ccf85377a3471ca8d2b0f98.svg";
export { ForwardRef as ReactComponent };